'use client';

import { use, useMemo } from 'react';
import { Container, Link, Text, Image, useTranslation } from '@weareconceptstudio/core';

//* Libs
// import { fetchData } from '@/libs/get-data';

//* Styles
import FooterStyle from './style';

//* Helpers
import { config } from '@/helpers';

//* Components
import Logo from '../Logo';

const Footer = () => {
	const { translate, selectedLang } = useTranslation();

	// const data = use(fetchData({ name: 'featuredItems', lang: selectedLang }));

	const footerStore = useMemo(() => {
		return Object.entries(config.routes)
			.slice(0, 5)
			.map(([key, val]) => (
				<div
					className='outside-wrapper-footer-menu-item'
					key={key}
				>
					<div className='footer-menu-item-wrapper'>
						<Link
							href={val.path}
							className='footer-menu-item-link uppercase font-ogg-medium white-1000'
						>
							{translate(val.name)}
						</Link>
						<Link
							href={val.path}
							className='footer-menu-item-link-hover uppercase font-ogg-medium white-1000'
						>
							{translate(val.name)}
						</Link>
					</div>
				</div>
			));
	}, []);

	return (
		<FooterStyle>
			<Container className={'footer-wrapper'}>
				<div className={'row'}>
					<div className={'col-7 col-dx-8 col-m-6'}>
						<div className={'footer-pages-wrapper'}>{footerStore}</div>
					</div>
					<div className={'col-2 col-dx-1 col-m-12 empty-div'} />
					<div className={'col-3 col-dx-3 col-m-6'}>
						{/* <div className={'footer-imgs-wrapper'}>
							{data.map((el, i) => {
								return (
									<div
										key={i}
										className={'footer-img-wrapper'}>
										{el.link ? (
											<Link
												url={el.link}
												external>
												<Image
													src={el.white_logo.src}
													alt={el.white_logo.alt}
												/>
											</Link>
										) : (
											<Image
												src={el.white_logo.src}
												alt={el.white_logo.alt}
											/>
										)}
									</div>
								);
							})}
						</div> */}
					</div>
				</div>

				<div className={'footer-bottom-wrapper'}>
					<div className={'row'}>
						<div className={'col-4 col-dl-3 col-dx-4 col-m-9'}>
							<div className={'footer-logo-wrapper'}>
								<Logo />
							</div>
						</div>
						<div className={'col-8 col-dl-9 col-dx-8 col-m-3'} />
					</div>

					<div className={'bottom-links-wrapper'}>
						<div className={'left-wrapper'}>
							<Text className='p5 font-neue-light'>
								©{new Date().getFullYear()} Avagyan. {translate('rightsReserved')}
							</Text>
						</div>
						<div className={'right-wrapper'}>
							<Text className='p5 font-neue-light'>
								{translate('madeBy')}&nbsp;
								<Link
									external
									url='https://conceptstudio.com/'
									className='office-name-link underline'
								>
									<span className='footer-office-name'>Concept Studio</span>
								</Link>
							</Text>
							<Link
								url={config.routes.termsConditions.path}
								className='terms-of-use-link underline'
							>
								<Text
									text={config.routes.termsConditions.name}
									className='p5 font-neue-light'
								/>
							</Link>
						</div>
					</div>
				</div>
			</Container>
		</FooterStyle>
	);
};

export default Footer;
